import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FilterAttributeRangeComponentDef } from '@df/catalog-ui/listing/filter/filter-attribute-range.component.def';
import { Model } from '@df/catalog/model';
import { ZippyModule } from '@df/legacy/ui/zippy/zippy.module';
import { NgInject } from '@df/ng/ng-inject';
import { PriceService } from '@df/ui/price/price.service';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { TranslationService } from '@df/ui/translation/translation.service';
import { ExpandableComponent } from 'projects/app-default/src/app/ui/display/expandable/expandable.component';
@Component({
    selector: 'filter-attribute-range',
    templateUrl: './filter-attribute-range.html',
    standalone: true,
    imports: [ExpandableComponent, ZippyModule, TranslationModule, FormsModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilterAttributeRangeComponent<T extends Model> extends FilterAttributeRangeComponentDef<T> {
    @NgInject(PriceService)
    private priceService: PriceService;
    @NgInject(TranslationService)
    private translationService: TranslationService;
    zippyId() {
        return ['filter', this.filter.id];
    }
    get getSelectedOptionsForFilter(): string {
        const min = this.filter.min;
        const max = this.filter.max;
        let output = '';
        if (min) {
            output += `${this.translationService.transform('from')} ${this.priceService.toHtmlString(min)}`;
        }
        if (max) {
            if (min) {
                output += ' ';
            }
            output += `${this.translationService.transform('to')} ${this.priceService.toHtmlString(max)}`;
        }
        return output;
    }

    get min(): number | undefined {
        return 0;
    }

    get max(): number | undefined {
        return undefined;
    }

    get minModel(): number | undefined {
        return this.filter.min;
    }

    set minModel(value: number | undefined) {
        this.filter.min = value;
    }

    get maxModel(): number | undefined {
        return this.filter.max;
    }

    set maxModel(value: number | undefined) {
        this.filter.max = value;
    }

    get label(): string | undefined {
        return this.filter.attribute.data?.label;
    }

    onMinChange(value): void {}

    onMaxChange(value): void {}
}
